import { useState } from "react";
import DashboardLayout from "../../../shared/DashboardLayout";

const AddEditExpenses = () => {
  const [formData, setFormData] = useState({
    expenseAmount: "",
    expenseDate: "",
    expenseBy: "",
    expenseType: "",
    expenseProjectName: "",
    expenseLaborName: "",
    expenseWorkerName: "",
    expenseLaborType: "",
    expenseMaterialType: "",
    expenseQuantity: "",
    expensePaymentDescription: "",
    expensePaymentMethod: "0",
    isPartial: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data Submitted:", formData);
    // Perform submission logic here (e.g., API call)
  };

  return (
    <DashboardLayout>
      <form onSubmit={handleSubmit} className="m-4">
        <h2 className="m-4">New Expenses</h2>

        <div className="row m-4">
          <div className="col-lg-4">
            <label htmlFor="expenseAmount" className="form-label fw-bolder">
              Amount <span className="required">*</span>
            </label>
          </div>
          <div className="col-lg-8 form-group">
            <input
              type="text"
              className="form-control"
              name="expenseAmount"
              id="expenseAmount"
              value={formData.expenseAmount}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-lg-4">
            <label htmlFor="expenseDate" className="form-label fw-bolder">
              Paid Date <span className="required">*</span>
            </label>
          </div>
          <div className="col-lg-8 form-group">
            <input
              type="date"
              className="form-control"
              name="expenseDate"
              id="expenseDate"
              value={formData.expenseDate}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-lg-4">
            <label htmlFor="expenseBy" className="form-label fw-bolder">
              Expense By
            </label>
          </div>
          <div className="col-lg-8 form-group">
            <select
              name="expenseBy"
              id="expenseBy"
              className="form-control"
              value={formData.expenseBy}
              onChange={handleChange}
            >
              <option value="">-- Select --</option>
              <option value="1">CA Exp</option>
              <option value="22">CEO Exp</option>
              <option value="77">NIL</option>
            </select>
          </div>

          <div className="col-lg-4">
            <label htmlFor="expenseType" className="form-label fw-bolder">
              Expense Type
            </label>
          </div>
          <div className="col-lg-8 form-group">
            <select
              name="expenseType"
              id="expenseType"
              className="form-control"
              value={formData.expenseType}
              onChange={handleChange}
            >
              <option value="3">MATERIAL</option>
              <option value="4">LABOR</option>
              <option value="5">SALARIES</option>
              <option value="6">OFFICE</option>
              <option value="31">LAND</option>
              <option value="32">GOVT TAX</option>
            </select>
          </div>

          <div className="col-lg-4">
            <label
              htmlFor="expenseProjectName"
              className="form-label fw-bolder"
            >
              Project
            </label>
          </div>
          <div className="col-lg-8 form-group">
            <select
              name="expenseProjectName"
              id="expenseProjectName"
              className="form-control"
              value={formData.expenseProjectName}
              onChange={handleChange}
            >
              <option value="">-- Select --</option>
              <option value="a">A Block</option>
              <option value="b">B Block</option>
              <option value="c">C Block</option>
              <option value="d">D Block</option>
              <option value="e">E Block</option>
            </select>
          </div>

          <div className="col-lg-4">
            <label htmlFor="expenseLaborName" className="form-label fw-bolder">
              Worker Name
            </label>
          </div>
          <div className="col-lg-8 form-group">
            <input
              type="text"
              className="form-control"
              name="expenseLaborName"
              id="expenseLaborName"
              value={formData.expenseLaborName}
              onChange={handleChange}
            />
          </div>

          <div className="col-lg-4">
            <label htmlFor="expenseWorkerName" className="form-label fw-bolder">
              Employee Name
            </label>
          </div>
          <div className="col-lg-8 form-group">
            <select
              name="expenseWorkerName"
              id="expenseWorkerName"
              className="form-control"
              value={formData.expenseWorkerName}
              onChange={handleChange}
            >
              <option value="">-- Select --</option>
              <option value="CH IMTIAZ ALI">CH IMTIAZ ALI</option>
              <option value="CH WAQAR AHMAD">CH WAQAR AHMAD</option>
              <option value="MALIK IQBAL">MALIK IQBAL</option>
            </select>
          </div>

          <div className="col-lg-4">
            <label htmlFor="expenseLaborType" className="form-label fw-bolder">
              Labor Category
            </label>
          </div>
          <div className="col-lg-8 form-group">
            <select
              name="expenseLaborType"
              id="expenseLaborType"
              className="form-control"
              value={formData.expenseLaborType}
              onChange={handleChange}
            >
              <option value="">-- Select --</option>
              <option value="8">ELECTRICIAN LABOR</option>
              <option value="9">SANITARY LABOR</option>
            </select>
          </div>

          <div className="col-lg-4">
            <label htmlFor="expenseQuantity" className="form-label fw-bolder">
              Quantity
            </label>
          </div>
          <div className="col-lg-8 form-group">
            <input
              type="text"
              className="form-control"
              name="expenseQuantity"
              id="expenseQuantity"
              value={formData.expenseQuantity}
              onChange={handleChange}
            />
          </div>

          <div className="col-lg-4">
            <label
              htmlFor="expensePaymentMethod"
              className="form-label fw-bolder"
            >
              Payment Method <span className="required">*</span>
            </label>
          </div>
          <div className="col-lg-8 form-group">
            <select
              name="expensePaymentMethod"
              id="expensePaymentMethod"
              className="form-control"
              value={formData.expensePaymentMethod}
              onChange={handleChange}
            >
              <option value="0">Cash</option>
              <option value="1">Bank</option>
            </select>
          </div>

          <div className="col-lg-4">
            <label htmlFor="isPartial" className="form-label fw-bolder">
              Is Partial?
            </label>
          </div>
          <div className="col-lg-8 form-group">
            <input
              type="checkbox"
              name="isPartial"
              id="isPartial"
              checked={formData.isPartial}
              onChange={handleChange}
            />
          </div>

          <div className="col-lg-4">
            <button className="btn site_btn text-white" type="submit">
              Add Expenses
            </button>
          </div>
        </div>
      </form>
    </DashboardLayout>
  );
};

export default AddEditExpenses;
